export default "__VITE_ASSET__DJUdITlf__"